export default __webpack_public_path__ + "static/Home-768-314bd05809edcb63b1665cc329a7c079.webp";